export const FETCH_MULTICONTRACT_RELATIONS         = 'FETCH_MULTICONTRACT_RELATIONS';
export const FETCH_MULTICONTRACT_RELATIONS_SUCCESS = 'FETCH_MULTICONTRACT_RELATIONS_SUCCESS';
export const FETCH_MULTICONTRACT_RELATIONS_FAILURE = 'FETCH_MULTICONTRACT_RELATIONS_FAILURE';

export const CREATE_MULTICONTRACT_RELATION         = 'CREATE_MULTICONTRACT_RELATION';
export const CREATE_MULTICONTRACT_RELATION_SUCCESS = 'CREATE_MULTICONTRACT_RELATION_SUCCESS';
export const CREATE_MULTICONTRACT_RELATION_FAILURE = 'CREATE_MULTICONTRACT_RELATION_FAILURE';

export const SEARCH_BENEFIT_SPONSOR_CONTRACT_ORG_RELATIONS
  = 'SEARCH_BENEFIT_SPONSOR_CONTRACT_ORG_RELATIONS';
export const SEARCH_BENEFIT_SPONSOR_CONTRACT_ORG_RELATIONS_SUCCESS
  = 'SEARCH_BENEFIT_SPONSOR_CONTRACT_ORG_RELATIONS_SUCCESS';
export const SEARCH_BENEFIT_SPONSOR_CONTRACT_ORG_RELATIONS_FAILURE
  = 'SEARCH_BENEFIT_SPONSOR_CONTRACT_ORG_RELATIONS_FAILURE';

export function searchBenefitSponsorContractRelations(data) {
  return {
    type:    SEARCH_BENEFIT_SPONSOR_CONTRACT_ORG_RELATIONS,
    payload: data
  };
}

export function searchBenefitSponsorContractOrgRelationsSuccess(response, orgSide) {
  return {
    type:    SEARCH_BENEFIT_SPONSOR_CONTRACT_ORG_RELATIONS_SUCCESS,
    payload: response,
    orgSide
  };
}

export function searchBenefitSponsorContractOrgRelationsFailure(errors) {
  return {
    type:    SEARCH_BENEFIT_SPONSOR_CONTRACT_ORG_RELATIONS_FAILURE,
    payload: errors
  };
}

export function fetchMultiContractRelationAction(data) {
  return {
    type:    FETCH_MULTICONTRACT_RELATIONS,
    payload: data
  };
}

export function fetchMultiContractRelationSuccess(response) {
  return {
    type:    FETCH_MULTICONTRACT_RELATIONS_SUCCESS,
    payload: response
  };
}

export function fetcMultiContractRelationFailure(errors) {
  return {
    type:    FETCH_MULTICONTRACT_RELATIONS_FAILURE,
    payload: errors
  };
}

export function createMultiContractRelationAction(data) {
  return {
    type:    CREATE_MULTICONTRACT_RELATION,
    payload: data
  };
}

export function createMultiContractRelationSuccess(response) {
  return {
    type:    CREATE_MULTICONTRACT_RELATION_SUCCESS,
    payload: response
  };
}

export function createMultiContractRelationFailure(errors) {
  return {
    type:    CREATE_MULTICONTRACT_RELATION_FAILURE,
    payload: errors
  };
}
